import { render } from "./SideBarMenuMobile.vue?vue&type=template&id=0f71b115&scoped=true"
import script from "./SideBarMenuMobile.vue?vue&type=script&lang=js"
export * from "./SideBarMenuMobile.vue?vue&type=script&lang=js"

import "./SideBarMenuMobile.vue?vue&type=style&index=0&id=0f71b115&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f71b115"]])

export default __exports__